import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { ReactNode } from "react";
import theme from "../../theme";
import { useWindowSize } from "@reactuses/core";

const { md } = theme.screen;

type Props = {
  title: string; // 대분류 제목
  children: ReactNode; // 소분류 메뉴들
};
export const Category = ({ title, children }: Props) => {
  const { width } = useWindowSize();

  return (
    <Box
      sx={{
        display: "flex",
        gap: width <= md ? "0px" : "96px",
        flexDirection: width <= md ? "column" : "row",
      }}
    >
      {/* 타이틀 영역 */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: width <= md ? "4px" : "6px",
          width: "160px",
        }}
      >
        {/* 아이콘 */}
        <Box
          sx={{
            display: "flex",
            gap: "4px",
          }}
        >
          <Circle
            style={{ backgroundColor: theme.color.green_600 }}
          ></Circle>
          <Circle
            style={{ backgroundColor: theme.color.green_400 }}
          ></Circle>
        </Box>

        {/* 타이틀 */}
        <Title>{title}</Title>
      </Box>

      <Box
        component={"ul"}
        sx={{
          display: "flex",
          gap: width <= md ? "8px" : "32px",
          flexDirection: width <= md ? "column" : "row",
          flexWrap: "wrap",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

const Circle = styled.div`
  width: 11px;
  height: 11px;
  border-radius: 100%;

  @media (max-width: ${md}px) {
    width: 8px;
    height: 8px;
  }
`;

const Title = styled.h3`
  height: 38px;
  line-height: 38px;
  font-size: 26px;
  font-weight: 500;
  color: ${theme.color.neutral_700};
  letter-spacing: -1.3px;

  @media (max-width: ${md}px) {
    font-size: 20px;
  }
`;
